export * from './tick-tock.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/tick-tock/index.ts